<template>
  <div class="fd-home-content">
    <div id="fd-header">
      <Header />
    </div>
    <div class="fd-content-box">
       <div class="fd-content-left"><leftMenu :menuList="menuList" :path='path'></leftMenu></div>
       <div class="fd-content-right">
           <keep-alive :include="syxw" :exclude='leftMenu'>
        <router-view :key="key"></router-view>
      </keep-alive>
       </div>
    </div>
    <!-- <leftMenu :menuList="menuList" :path='$router.currentRoute.path'></leftMenu>
      <keep-alive :include="syxw" :exclude='leftMenu'>
        <router-view :key="key"></router-view>
      </keep-alive> -->
    <!-- </div> -->
    <div id="fd-footer">
      <div style="margin:3vh auto;text-align:center;color:#fff">
        浙江省社会主义学院 版权所有 <el-link href="http://beian.miit.gov.cn" target="_blank">
          <p style="color:#fff">浙ICP备10003666号-1</p>
        </el-link><br /><br />
        地址：浙江省杭州市文一西路1008号 邮编：311121 <span @click="getLaw" class="fd-lawStyle">法律声明</span><br /><br />
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header.vue';
import leftMenu from '../components/leftMenu.vue';
export default {
  components: {
    Header,
    leftMenu
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  data() {
    return {};
  },
  created(){
   this.menuList = JSON.parse(localStorage.getItem('menuList'));
   this.path = this.$route.query.path;
   debugger
  },
  mounted() {
    this.columnCode = this.$route.query.columnCode;
    
    // console.log(this.$route.fullPath, '23123');
  },
  methods: {
    getLaw() {
      localStorage.setItem('menuList', []);
      this.$router.push({
        path: '/wwnry',
        query: {
          columnCode: 'SYZT_FLSM',
        },
      });
    },
  },
};
</script>
<style>
.fd-home-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: url('../assets/images/portalBg.png') no-repeat bottom;
  overflow-x: hidden;
}
#fd-header {
  width: 100%;
  /* height: 400px; */
  /* background: #1A73E7; */
}
#fd-content {
  /* flex: 1; */
  /* background: red; */
  width: 1420px;
  margin: 0 auto;
}
#fd-footer {
  width: 100%;
  height: 20%;
  background: #1a81e7;
}
.fd-lawStyle {
  cursor: pointer;
}
.fd-content-box{
    width: calc(100% - 400px);
    margin: 0 auto;
    margin-top: 40px;
}
.fd-content-left{
    width: 263px;
    float: left;
    min-height: 832px;
    background: #fff;
    margin-right: 10px;
}
.fd-content-right{
  width: calc(100% - 273px);
  float: left;
}
@media (min-width:0px) and (max-width:1000px){
  .fd-content-box{
    width: 100%;
    margin-top: 40px;
}
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue